/* ATELIER NAV DATA - GENERATED by _gen-nav-v2-data.py --theme, do not
   hand-edit. The v2 nav tree; every link validated against the store's
   real collections; thumbnails = cutout PNGs on Shopify Files
   (upload log: _nav-thumb-files-log.csv). Loaded by
   sections/atelier-header.liquid BEFORE atelier-header.js. */
window.NAV2 = {
 "mega": {
  "bathroom": {
   "t": "Bathroom",
   "ptype": "rail",
   "all": "/collections",
   "cats": [
    {
     "k": "toilets",
     "t": "Toilets",
     "hub": "/pages/toilet-suites",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ToiletsHero_WallSuites_1.jpg",
     "groups": [
      {
       "h": "By type",
       "links": [
        {
         "l": "Back-to-Wall Suites",
         "h": "/collections/back-to-wall-toilet-suites",
         "n": 38,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-toilet-suites.png?v=1782979632",
         "cut": 1,
         "bg": "cutout",
         "pv": "BP-T3_1.webp"
        },
        {
         "l": "In-Wall Toilet Packages",
         "h": "/collections/in-wall-toilet-packages",
         "n": 25,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-toilet-packages.png?v=1782979672",
         "cut": 1,
         "bg": "cutout",
         "pv": "BEWFP_1.webp"
        },
        {
         "l": "Wall Faced Pans",
         "h": "/collections/wall-faced-pans",
         "n": 14,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-faced-pans.png?v=1782979730",
         "cut": 1,
         "bg": "cutout",
         "pv": "Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg"
        },
        {
         "l": "Wall Hung Pans",
         "h": "/collections/wall-hung-pans",
         "n": 6,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-pans.png?v=1782979731",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Close Coupled Suites",
         "h": "/collections/close-coupled-toilet-suites",
         "n": 5,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-close-coupled-toilet-suites.png?v=1782979641",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Smart Toilets",
         "h": "/collections/smart-toilets",
         "n": 15,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-smart-toilets.png?v=1782979711",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      },
      {
       "h": "In-wall & parts",
       "links": [
        {
         "l": "Concealed Cisterns",
         "h": "/collections/in-wall-concealed-cisterns",
         "n": 8,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-concealed-cisterns.png?v=1782979672",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Cistern Buttons",
         "h": "/collections/in-wall-cistern-buttons",
         "n": 82,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-cistern-buttons.png?v=1782979661",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Bidet Sprays",
         "h": "/collections/bidet-sprays",
         "n": 21,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bidet-sprays.png?v=1782979631",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Spare Parts",
         "h": "/collections/toilet-spare-parts",
         "n": 43,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-toilet-spare-parts.png?v=1782979721",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "prod",
      "t": "Geberit Sigma 8 Milan Rimless In Wall Suite",
      "p": 621,
      "c": 1497,
      "h": "/products/geberit-sigma-8-isabella-rimless-in-wall-cistern-toilet-suite-colour-buttons-2",
      "i": "Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg"
     },
     "n": 257
    },
    {
     "k": "baths",
     "t": "Baths",
     "hub": "/pages/bathtubs",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/423807770_1049961749451743_2710686113473872051_n-1024x819.jpg",
     "groups": [
      {
       "h": "By type",
       "links": [
        {
         "l": "Freestanding Baths",
         "h": "/collections/freestanding-baths",
         "n": 143,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-baths.png?v=1782979661",
         "cut": 1,
         "bg": "cutout",
         "pv": "1700mm-Artemis_a005a0d3-aa4a-42c6-bdae-15d5fb2e5891.webp"
        },
        {
         "l": "Back to Wall Baths",
         "h": "/collections/back-to-wall-baths",
         "n": 34,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-baths.png?v=1782979632",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Corner Baths",
         "h": "/collections/corner-baths",
         "n": 44,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-corner-baths.png?v=1782979641",
         "cut": 1,
         "bg": "cutout",
         "pv": "vienna-lh-1.jpg"
        },
        {
         "l": "Multi-fit Baths",
         "h": "/collections/multi-fit-baths",
         "n": 13,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-multi-fit-baths.png?v=1782979682",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Stone Baths",
         "h": "/collections/stone-baths",
         "n": 46,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-stone-baths.png?v=1782979711",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      },
      {
       "h": "Finish the look",
       "links": [
        {
         "l": "Bath Wastes",
         "h": "/collections/bath-wastes",
         "n": 44,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Bath & Basin Spouts",
         "h": "/collections/bath-spouts",
         "n": 180,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-spouts.png?v=1782979632",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Freestanding Bath Mixers",
         "h": "/collections/freestanding-bath-mixers",
         "n": 119,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-bath-mixers.png?v=1782979651",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "prod",
      "t": "1700mm Artemis V-Groove Fluted Freestanding Bath",
      "p": 1038,
      "c": 2397,
      "h": "/products/1700mm-artemis-v-groove-fluted-free-standing-matte-white-bath-tub-no-overflow",
      "i": "1700mm-Artemis_a005a0d3-aa4a-42c6-bdae-15d5fb2e5891.webp"
     },
     "n": 623
    },
    {
     "k": "showers",
     "t": "Showers",
     "hub": "/pages/showers",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/455114UB-Lifestyle.jpg",
     "groups": [
      {
       "h": "By type",
       "links": [
        {
         "l": "2-in-1 Multi Function",
         "h": "/collections/shower-column-set",
         "n": 251,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-column-set.png?v=1782979691",
         "cut": 1,
         "bg": "cutout",
         "pv": "STR013-PBM90423W-32BM-scaled-1.jpg"
        },
        {
         "l": "Hand Shower on Rail",
         "h": "/collections/shower-on-rail",
         "n": 122,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-on-rail.png?v=1782979702",
         "cut": 1,
         "bg": "cutout",
         "pv": "STR013-PBN90423W-32BN-scaled-1.jpg"
        },
        {
         "l": "Shower Heads",
         "h": "/collections/shower-heads",
         "n": 183,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-heads.png?v=1782979702",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Shower Arms",
         "h": "/collections/shower-arms",
         "n": 162,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-arms.png?v=1782979691",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Hand Shower Pieces",
         "h": "/collections/hand-shower-piece",
         "n": 84,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-hand-shower-piece.png?v=1782979661",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Shower on Brackets",
         "h": "/collections/shower-brackets",
         "n": 148,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-brackets.png?v=1782979691",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      },
      {
       "h": "Screens & mixers",
       "links": [
        {
         "l": "Shower Screens",
         "h": "/collections/shower-screens",
         "n": 49
        },
        {
         "l": "Screen Accessories",
         "h": "/collections/shower-screen-accessories",
         "n": 29,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-screen-accessories.png?v=1782979702",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Shower / Wall Mixers",
         "h": "/collections/shower-wall-mixers",
         "n": 244,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wall-mixers.png?v=1782979702",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "prod",
      "t": "Ovia Brushed Gold Trade 2-in-1 Twin Rail System",
      "p": 318,
      "c": 699,
      "h": "/products/ovia-trade-2-in-1-multi-function-shower-station-brushed-gold-pvd",
      "i": "STR013-PBM90423W-32BM-scaled-1.jpg"
     },
     "n": 1272
    },
    {
     "k": "basins",
     "t": "Basins",
     "hub": "/pages/basins",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ovia-fluted.webp",
     "groups": [
      {
       "h": "By type",
       "links": [
        {
         "l": "Countertop Basins",
         "h": "/collections/counter-top-basins",
         "n": 254,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-counter-top-basins.png?v=1782979640",
         "cut": 1,
         "bg": "cutout",
         "pv": "hero_basin_ac-800x445-1.jpg"
        },
        {
         "l": "Wall Hung Basins",
         "h": "/collections/wall-hung-basins",
         "n": 37,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-basins.png?v=1782979730",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Undermount Basins",
         "h": "/collections/under-basins",
         "n": 39,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-under-basins.png?v=1782979721",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Semi-inset Basins",
         "h": "/collections/semi-inset-basins",
         "n": 39,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-semi-inset-basins.png?v=1782979691",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Freestanding Basins",
         "h": "/collections/freestanding-basins",
         "n": 7,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-basins.png?v=1782979651",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Inset Basins",
         "h": "/collections/inset-basins",
         "n": 10,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-inset-basins.png?v=1782979672",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Compact Basins",
         "h": "/collections/compact-basins",
         "n": 6,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-compact-basins.png?v=1782979641",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Cast Stone Basins",
         "h": "/collections/cast-stone-basins",
         "n": 61,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cast-stone-basins.png?v=1782979641",
         "cut": 1,
         "bg": "cutout",
         "pv": "ovia-fluted.webp"
        }
       ]
      },
      {
       "h": "Wastes & traps",
       "links": [
        {
         "l": "Pop-up Wastes",
         "h": "/collections/pop-up-wastes",
         "n": 47,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pop-up-wastes.png?v=1782979682",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Bottle Traps",
         "h": "/collections/bottle-traps",
         "n": 21,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "prod",
      "t": "Ovia Matte White 360mm Round Counter Top Basin",
      "p": 126,
      "c": 399,
      "h": "/products/ovia-matt-white-360mm-round-counter-top-basin",
      "i": "360-Gloss.png"
     },
     "n": 521
    },
    {
     "k": "vanities",
     "t": "Vanities",
     "hub": "/pages/vanities",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/150RWC_2-1.jpg",
     "groups": [
      {
       "h": "By type",
       "links": [
        {
         "l": "Wall Hung Vanities",
         "h": "/collections/wall-hung-vanities",
         "n": 159,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-vanities.png?v=1782979731",
         "cut": 1,
         "bg": "cutout",
         "pv": "HE-90W-TO.webp"
        },
        {
         "l": "Vanities on Legs",
         "h": "/collections/vanities-on-legs",
         "n": 22,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-legs.png?v=1782979731",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Vanities on Kickboard",
         "h": "/collections/vanities-on-kickboard",
         "n": 35,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-kickboard.png?v=1782979721",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Small Space Vanities",
         "h": "/collections/small-spaces-vanities",
         "n": 36,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-small-spaces-vanities.png?v=1782979711",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      },
      {
       "h": "Extras",
       "links": [
        {
         "l": "Stone Tops",
         "h": "/collections/stone-tops",
         "n": 16,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-stone-tops.png?v=1782979711",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Vanity Tops",
         "h": "/collections/vanity-tops-bathroom-vanities",
         "n": 39,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanity-tops-bathroom-vanities.png?v=1782979730",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Cabinet Handles",
         "h": "/collections/cabinet-handles",
         "n": 140,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cabinet-handles.png?v=1782979641",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Vanity Builder",
         "h": "/collections/vanity-builder",
         "n": 18,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanity-builder.png?v=1782979731",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "tile",
      "k": "Design tool",
      "tag": "NEW",
      "t": "Design your dream vanity",
      "go": "Start building \u2192",
      "h": "/collections/vanity-builder",
      "i": "HE-90W-TO.webp"
     },
     "n": 465
    },
    {
     "k": "mirrors",
     "t": "Mirrors & Cabinets",
     "hub": "/pages/mirrors-shaving-cabinets",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/hero_kaya_led_mirror.jpg",
     "groups": [
      {
       "h": "Mirrors",
       "links": [
        {
         "l": "LED Mirrors",
         "h": "/collections/led-mirrors",
         "n": 82,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-led-mirrors.png?v=1782979682",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Round Mirrors",
         "h": "/collections/rounds",
         "n": 13,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-rounds.png?v=1782979691",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Pencil Edge Mirrors",
         "h": "/collections/pencil-edge-mirrors",
         "n": 23,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pencil-edge-mirrors.png?v=1782979681",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Framed Coloured Mirrors",
         "h": "/collections/framed-coloured-mirrors",
         "n": 52,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-framed-coloured-mirrors.png?v=1782979651",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      },
      {
       "h": "Cabinets",
       "links": [
        {
         "l": "Shaving Cabinets",
         "h": "/collections/shaving-cabinets",
         "n": 111,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shaving-cabinets.png?v=1782979691",
         "cut": 1,
         "bg": "cutout",
         "pv": "PSC1200SX-fienza-lifestyle.webp"
        },
        {
         "l": "LED Shaving Cabinets",
         "h": "/collections/led-shaving-cabinets",
         "n": 43,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-led-shaving-cabinets.png?v=1782979682",
         "cut": 1,
         "bg": "cutout",
         "pv": "AT-5090A-MW1.webp"
        }
       ]
      }
     ],
     "feat": {
      "type": "prod",
      "t": "Athena 500x800mm LED Arch Shaving Cabinet",
      "p": 809,
      "c": 1097,
      "h": "/products/mercio-athena-500-x-800mm-led-arch-wall-hung-shaving-cabinet-single-door",
      "i": "AT-5090A-MW1.webp"
     },
     "n": 324
    },
    {
     "k": "accessories",
     "t": "Accessories",
     "hub": "/pages/bathroom-accessories",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/AccessoriesHero_Toilet.jpg",
     "groups": [
      {
       "h": "Essentials",
       "links": [
        {
         "l": "Towel Bars & Rails",
         "h": "/collections/towel-bar-rails",
         "n": 406,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-towel-bar-rails.png?v=1782979721",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Toilet Paper Holders",
         "h": "/collections/paper-holders",
         "n": 126,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-paper-holders.png?v=1782979682",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Robe Hooks",
         "h": "/collections/robe-hooks",
         "n": 122,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-robe-hooks.png?v=1782979691",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Towel Rings",
         "h": "/collections/towel-rings",
         "n": 70,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-towel-rings.png?v=1782979721",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Bath Shelves",
         "h": "/collections/bathroom-shelves",
         "n": 47,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bathroom-shelves.png?v=1782979631",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Soap Dish Holders",
         "h": "/collections/soap-dish-holders",
         "n": 37,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-soap-dish-holders.png?v=1782979711",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Soap Dispensers",
         "h": "/collections/soap-dispenser",
         "n": 15,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-soap-dispenser.png?v=1782979711",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Toilet Brush Holders",
         "h": "/collections/toilet-brush-holder",
         "n": 22,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-toilet-brush-holder.png?v=1782979721",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      },
      {
       "h": "Warm & practical",
       "links": [
        {
         "l": "Heated Towel Rails",
         "h": "/collections/heated-rails",
         "n": 131,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heated-rails.png?v=1782979661",
         "cut": 1,
         "bg": "cutout",
         "pv": "meir-verticalheatedrail-lifestyle.png"
        }
       ]
      }
     ],
     "feat": {
      "type": "tile",
      "k": "Complete the room",
      "t": "Matching accessories in every finish",
      "go": "Browse the range \u2192",
      "h": "/collections/bathroom-accessories",
      "i": "AccessoriesHero_Toilet.jpg"
     },
     "n": 976
    },
    {
     "k": "heating",
     "t": "Heating & Cooling",
     "hub": "/pages/heating-cooling",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-and-cooling.png?v=1782979661",
     "groups": [
      {
       "h": "Keep it warm",
       "links": [
        {
         "l": "Heated Towel Rails",
         "h": "/collections/heated-rails",
         "n": 131,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heated-rails.png?v=1782979661",
         "cut": 1,
         "bg": "cutout",
         "pv": "meir-verticalheatedrail-lifestyle.png"
        },
        {
         "l": "Underfloor Heating",
         "h": "/collections/underfloor-heating",
         "n": 62,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-underfloor-heating.png?v=1782979721",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Heating Thermostats",
         "h": "/collections/heating-thermostats",
         "n": 7,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-thermostats.png?v=1782979661",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "All Heating & Cooling",
         "h": "/collections/heating-and-cooling",
         "n": 155,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-and-cooling.png?v=1782979661",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "tile",
      "k": "Warm & practical",
      "t": "Heated rails & underfloor heating",
      "go": "Browse heating \u2192",
      "h": "/collections/heating-and-cooling",
      "i": "meir-verticalheatedrail-lifestyle.png"
     },
     "n": 355
    },
    {
     "k": "wastes",
     "t": "Wastes & Traps",
     "hub": "/pages/shower-wastes",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/floorwaste-lifestyle.jpg",
     "groups": [
      {
       "h": "By type",
       "links": [
        {
         "l": "Floor Wastes",
         "h": "/collections/floor-wastes",
         "n": 76,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-floor-wastes.png?v=1782979651",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Shower Wastes",
         "h": "/collections/shower-wastes",
         "n": 88,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wastes.png?v=1782979702",
         "cut": 1,
         "bg": "cutout",
         "pv": "floorwaste-lifestyle.jpg"
        },
        {
         "l": "Wedge Wire Channels",
         "h": "/collections/wedge-wire-tile-insert-channels",
         "n": 15,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wedge-wire-tile-insert-channels.png?v=1782979736",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Bath Wastes",
         "h": "/collections/bath-wastes",
         "n": 44,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Pop-up Wastes",
         "h": "/collections/pop-up-wastes",
         "n": 47,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pop-up-wastes.png?v=1782979682",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Bottle Traps",
         "h": "/collections/bottle-traps",
         "n": 21,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "tile",
      "k": "Floor & shower",
      "t": "Grates, channels & wastes",
      "go": "Browse wastes \u2192",
      "h": "/collections/floor-wastes",
      "i": "floorwaste-lifestyle.jpg"
     },
     "n": 291
    },
    {
     "k": "care",
     "t": "Care & Ambulant",
     "hub": "/pages/disabled-care",
     "railImg": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-special-disabled.png?v=1782979711",
     "groups": [
      {
       "h": "Accessible bathrooms",
       "links": [
        {
         "l": "All Care Products",
         "h": "/collections/special-disabled",
         "n": 57,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-special-disabled.png?v=1782979711",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Care Toilet Suites",
         "h": "/collections/disabled-toilet-suites",
         "n": 34,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-disabled-toilet-suites.png?v=1782979651",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Grab Rails & Back Rests",
         "h": "/collections/grab-rails-back-rests",
         "n": 28,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-grab-rails-back-rests.png?v=1782979661",
         "cut": 1,
         "bg": "cutout"
        },
        {
         "l": "Care Tapware",
         "h": "/collections/disability-tapware",
         "n": 9,
         "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-disability-tapware.png?v=1782979651",
         "cut": 1,
         "bg": "cutout"
        }
       ]
      }
     ],
     "feat": {
      "type": "tile",
      "k": "Care range",
      "t": "Accessible bathroom fit-outs",
      "go": "Browse the range \u2192",
      "h": "/collections/special-disabled",
      "i": "AccessoriesHero_Care-1.jpg"
     },
     "n": 128
    }
   ]
  },
  "kitchen": {
   "t": "Kitchen",
   "ptype": "std",
   "all": "/collections/kitchen",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/SinkHero_Butler2-600x333-1.jpg",
   "hub": "/pages/kitchen-laundry-sinks",
   "guideT": "Kitchen & laundry Hub",
   "quick": [
    [
     "Instant Ship",
     "/collections/instant-ship"
    ],
    [
     "Shop Packages",
     "/collections/bathroom-packages"
    ],
    [
     "Clearance",
     "/collections/clearance"
    ]
   ],
   "groups": [
    {
     "h": "Sinks",
     "links": [
      {
       "l": "All Kitchen Sinks",
       "h": "/collections/sinks-laundry-tubs",
       "n": 121,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sinks-laundry-tubs.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Single Bowl Sinks",
       "h": "/collections/single-bowls",
       "n": 80,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-single-bowls.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Double Bowl Sinks",
       "h": "/collections/double-bowls",
       "n": 40,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-double-bowls.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Butler Sinks",
       "h": "/collections/butlers-ceramic-sink",
       "n": 24,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-butlers-ceramic-sink.png?v=1782979641",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Granite Sinks",
       "h": "/collections/granite-sinks",
       "n": 55,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-granite-sinks.png?v=1782979661",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Sink Accessories",
       "h": "/collections/sink-accessories",
       "n": 71,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sink-accessories.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Tapware",
     "links": [
      {
       "l": "Kitchen Mixers",
       "h": "/collections/kitchen-mixers",
       "n": 421,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-kitchenmixer-tigerbronze-lifestyle.webp"
      },
      {
       "l": "Pull Out Kitchen Mixers",
       "h": "/collections/pull-out-kitchen-mixers",
       "n": 209,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pull-out-kitchen-mixers.png?v=1782979692",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Boiling, Chilled & Sparkling",
       "h": "/collections/boiling-chilled-sparkling-taps",
       "n": 8,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-boiling-chilled-sparkling-taps.png?v=1783035921",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Filter Taps",
       "h": "/collections/filter-taps",
       "n": 9,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-filter-taps.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Pot Fillers",
       "h": "/collections/pot-fillers",
       "n": 32,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pot-fillers.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Finishing touches",
     "links": [
      {
       "l": "Kitchen Accessories",
       "h": "/collections/kitchen-accessories",
       "n": 46,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-accessories.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ],
   "feat": {
    "type": "tile",
    "k": "Complete the kitchen",
    "t": "Sinks & mixers, made to match",
    "go": "Browse kitchen \u2192",
    "h": "/collections/kitchen",
    "i": "meir-kitchenmixer-tigerbronze-lifestyle.webp"
   }
  },
  "laundry": {
   "t": "Laundry",
   "ptype": "std",
   "all": "/collections/laundry-and-butler-sinks",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/meir-kitchenmixer-tigerbronze-lifestyle.webp",
   "hub": "/pages/kitchen-laundry-sinks",
   "guideT": "Kitchen & laundry Hub",
   "quick": [
    [
     "Instant Ship",
     "/collections/instant-ship"
    ],
    [
     "Shop Packages",
     "/collections/bathroom-packages"
    ],
    [
     "Clearance",
     "/collections/clearance"
    ]
   ],
   "groups": [
    {
     "h": "The laundry",
     "links": [
      {
       "l": "Laundry & Butler Sinks",
       "h": "/collections/laundry-and-butler-sinks",
       "n": 261,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-and-butler-sinks.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Laundry Tubs",
       "h": "/collections/laundry-tubs",
       "n": 9,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-tubs.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Laundry Mixers",
       "h": "/collections/laundry-mixers",
       "n": 129,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Wall Taps",
       "h": "/collections/wall-tap-assemblies",
       "n": 82,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-tap-assemblies.png?v=1782979736",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Finishing touches",
     "links": [
      {
       "l": "Heated Towel Rails",
       "h": "/collections/heated-rails",
       "n": 131,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heated-rails.png?v=1782979661",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-verticalheatedrail-lifestyle.png"
      },
      {
       "l": "Robe Hooks",
       "h": "/collections/robe-hooks",
       "n": 122,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-robe-hooks.png?v=1782979691",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ],
   "feat": {
    "type": "tile",
    "k": "Hard-working spaces",
    "t": "Sinks & tapware for the laundry",
    "go": "Browse laundry \u2192",
    "h": "/collections/laundry-and-butler-sinks",
    "i": "SinkHero_Butler2-600x333-1.jpg"
   }
  },
  "tapware": {
   "t": "Tapware",
   "ptype": "std",
   "all": "/pages/bathroom-tapware",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/434212207_3682553512029488_4123856708157861265_n-1024x768.jpg",
   "hub": "/pages/bathroom-tapware",
   "guideT": "Tapware Hub",
   "strip": "fin",
   "promo": 1,
   "feat": {
    "type": "prod",
    "t": "Ovia Milan Shower Bath Mixer Brushed Bronze",
    "p": 150,
    "c": 397,
    "h": "/products/ovia-milan-shower-bath-mixer-round-brushed-bronze",
    "i": "ChatGPT-Image-Apr-8-2025-02_26_28-PM_9667e08c-69bd-4d7e-bd1f-a905afe66050.png"
   },
   "groups": [
    {
     "h": "Bathroom",
     "links": [
      {
       "l": "Basin Mixers",
       "h": "/collections/basin-mixers",
       "n": 282,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-basin-mixers.png?v=1782979631",
       "cut": 1,
       "bg": "cutout",
       "pv": "ChatGPT-Image-Apr-8-2025-02_26_28-PM_9667e08c-69bd-4d7e-bd1f-a905afe66050.png"
      },
      {
       "l": "Tall Basin Mixers",
       "h": "/collections/tall-basin-mixers",
       "n": 136,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-tall-basin-mixers.png?v=1782979720",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Wall Basin Mixers",
       "h": "/collections/wall-basin-mixers",
       "n": 171,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-basin-mixers.png?v=1782979730",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Shower / Wall Mixers",
       "h": "/collections/shower-wall-mixers",
       "n": 244,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wall-mixers.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Diverter Mixers",
       "h": "/collections/shower-mixers-diverter",
       "n": 170,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-mixers-diverter.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Freestanding Bath Mixers",
       "h": "/collections/freestanding-bath-mixers",
       "n": 119,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-bath-mixers.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Wall Taps",
       "h": "/collections/wall-tap-assemblies",
       "n": 82,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-tap-assemblies.png?v=1782979736",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bath & Basin Spouts",
       "h": "/collections/bath-spouts",
       "n": 180,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-spouts.png?v=1782979632",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Kitchen & laundry",
     "links": [
      {
       "l": "Kitchen & Laundry Mixers",
       "h": "/collections/kitchen-mixers",
       "n": 421,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-kitchenmixer-tigerbronze-lifestyle.webp"
      },
      {
       "l": "Pull Out Kitchen Mixers",
       "h": "/collections/pull-out-kitchen-mixers",
       "n": 209,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pull-out-kitchen-mixers.png?v=1782979692",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Laundry Mixers",
       "h": "/collections/laundry-mixers",
       "n": 129,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Boiling, Chilled & Sparkling",
       "h": "/collections/boiling-chilled-sparkling-taps",
       "n": 8,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-boiling-chilled-sparkling-taps.png?v=1783035921",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Filter Taps",
       "h": "/collections/filter-taps",
       "n": 9,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-filter-taps.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Pot Fillers",
       "h": "/collections/pot-fillers",
       "n": 32,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pot-fillers.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Outdoor Kitchen Taps",
       "h": "/collections/outdoor-kitchen-taps",
       "n": 11,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-outdoor-kitchen-taps.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "colours": {
   "t": "Colours",
   "ptype": "colours",
   "all": "/pages/colours",
   "finishes": [
    {
     "l": "Antique Brass",
     "h": "/collections/antique-brass-tapware",
     "sw": "antique-brass"
    },
    {
     "l": "Brushed Nickel",
     "h": "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
     "sw": "brushed-nickel"
    },
    {
     "l": "Warm Brushed Nickel",
     "h": "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
     "sw": "warm-brushed-nickel"
    },
    {
     "l": "Brushed Gold",
     "h": "/collections/brushed-gold-tapware",
     "sw": "brushed-gold"
    },
    {
     "l": "Gunmetal",
     "h": "/collections/colour-gunmetal",
     "sw": "gunmetal"
    },
    {
     "l": "Matte White",
     "h": "/collections/colour-matte-white",
     "sw": "matte-white"
    },
    {
     "l": "Matte Black",
     "h": "/collections/colour-matte-black",
     "sw": "matte-black"
    },
    {
     "l": "Champagne",
     "h": "/collections/colour-champagne",
     "sw": "champagne"
    },
    {
     "l": "Chrome",
     "h": "/collections/colour-chrome",
     "sw": "chrome"
    },
    {
     "l": "Brushed Bronze",
     "h": "/collections/colour-brushed-bronze",
     "sw": "brushed-bronze"
    },
    {
     "l": "Brushed Copper",
     "h": "/collections/colour-brushed-copper",
     "sw": "brushed-copper"
    },
    {
     "l": "Black",
     "h": "/collections/colour-black",
     "sw": "black"
    },
    {
     "l": "Grey",
     "h": "/collections/colour-grey",
     "sw": "grey"
    },
    {
     "l": "Stainless Steel",
     "h": "/collections/colour-stainless-steel",
     "sw": "stainless-steel"
    },
    {
     "l": "White",
     "h": "/collections/colour-white",
     "sw": "white"
    }
   ]
  },
  "brands": {
   "t": "Brands",
   "ptype": "brands",
   "all": "/pages/brands",
   "featured": {
    "name": "Ovia",
    "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_ovia_product-150x150.png?v=1741661801",
    "h": "/collections/ovia",
    "n": 332,
    "d": "A complete bathroomware range \u2014 tapware, showers, basins, baths, toilet suites and accessories, with dedicated commercial and accessibility (care) lines. Practical, hard-wearing fixtures at fair everyday prices, so you can fit out a whole bathroom from one dependable range."
   },
   "brands": [
    {
     "name": "Fienza",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/FienzaLogo-1.png?v=1741662706",
     "h": "/collections/fienza",
     "n": 1049,
     "d": "Established Australian brand with one of the widest bathroom ranges \u2014 vanities (including Australian-made cabinetry), tapware, basins, baths and toilets \u2014 backed by strong warranties."
    },
    {
     "name": "Nero",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/NeroLogo-1.png?v=1741662670",
     "h": "/collections/nero",
     "n": 1028,
     "d": "Australian-designed solid-brass tapware and mixers for bath, kitchen and laundry across a wide finish range \u2014 quality styling at accessible mid-range pricing."
    },
    {
     "name": "Meir",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MeirLogo-1.png?v=1741662639",
     "h": "/collections/meir",
     "n": 652,
     "d": "Australian designer brand known for premium tapware and showers in bold finishes \u2014 matte black, aged brass, rose gold \u2014 built from DZR brass and backed by a lifetime guarantee."
    },
    {
     "name": "Modern National",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ModernNationalLogo-1.png?v=1741663791",
     "h": "/collections/modern-national",
     "n": 418,
     "d": "Australian-owned brand bringing current design to tapware, showers, baths and accessories in solid brass, at an approachable mid-range price."
    },
    {
     "name": "ADP",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ADPLogo-1_1.png?v=1741664296",
     "h": "/collections/architectural-designer-products-adp",
     "n": 376,
     "d": "Australian family-owned manufacturer of premium, Australian-made bathroom furniture \u2014 vanities, mirrored cabinets, basins, mirrors and baths \u2014 crafted in its own factory south of Sydney."
    },
    {
     "name": "Greens Tapware",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_green-150x150.png?v=1741659584",
     "h": "/collections/greens-tapwares",
     "n": 284,
     "d": "New Zealand-designed tapware and showers with heritage back to 1935 \u2014 design- and engineering-led, meeting Australian and NZ standards."
    },
    {
     "name": "Mercio",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MercioLogo-1.png?v=1741664296",
     "h": "/collections/mercio",
     "n": 208,
     "d": "Australian bathroom supplier with a broad, well-stocked range \u2014 vanities, basins (ceramic and stone), toilets, baths, tapware and mirrors \u2014 backing renovators and builders with locally held stock."
    },
    {
     "name": "Aquaperla",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/AquaperlaLogo-1.png?v=1741664286",
     "h": "/collections/aquaperla",
     "n": 194,
     "d": "Proudly Australian-owned, offering well-priced, modern tapware and fixtures for bathroom, kitchen and laundry \u2014 compliant with Australian plumbing standards."
    },
    {
     "name": "Poseidon",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/PoseidonLogo-1.png?v=1741664286",
     "h": "/collections/poseidon",
     "n": 119,
     "d": "Value-focused wholesale bath and kitchen brand \u2014 tapware, basins, vanities, baths and toilets \u2014 sourced overseas to keep pricing sharp, distributed Australia-wide."
    },
    {
     "name": "Metlam",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/MetlamLogo-1.png?v=1741663836",
     "h": "/collections/metlam",
     "n": 116,
     "d": ""
    },
    {
     "name": "Geberit",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/GeberitLogo-1.png?v=1741663836",
     "h": "/collections/geberit",
     "n": 81,
     "d": "A global leader in concealed sanitary technology \u2014 Swiss-designed, German-made in-wall cisterns and flush plates (Sigma, Omega, Alpha) engineered for quiet, water-efficient dual flushing."
    },
    {
     "name": "Linkware",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/LinkwareLogo-1.png?v=1741664296",
     "h": "/collections/linkware",
     "n": 80,
     "d": "Australian designer and manufacturer of value-focused tapware and bathroom brassware, accredited to Australian Standards and widely stocked."
    },
    {
     "name": "Linsol",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_linsol-200x125-1.png?v=1740976026",
     "h": "/collections/linsol",
     "n": 60,
     "d": "Australian family-grown bathware brand best known for durable, energy-efficient heated towel rails, alongside tapware and mixers."
    },
    {
     "name": "Thermogroup",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_thermogroup-200x125-1.png?v=1740976025",
     "h": "/collections/thermogroup",
     "n": 43,
     "d": "Australian-owned heating specialist and trade favourite \u2014 Thermorail heated towel rails, underfloor heating, LED mirrors and smart thermostats, built for easy install and efficiency."
    },
    {
     "name": "Madu Living",
     "logo": null,
     "h": "/collections/madu-living",
     "n": 30,
     "d": ""
    },
    {
     "name": "ART Australia",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/bsd_art_australia-150x150.png?v=1741661801",
     "h": "/collections/art-australia",
     "n": 23,
     "d": ""
    },
    {
     "name": "Oliveri",
     "logo": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/OliveriLogo-1.png?v=1741663836",
     "h": "/collections/oliveri",
     "n": 22,
     "d": "South Australian icon making kitchen and laundry sinks in Adelaide since 1947 \u2014 the pioneer of the pressed-bowl process \u2014 plus taps and water filtration."
    }
   ]
  }
 },
 "finishes": [
  [
   "Antique Brass",
   "/collections/antique-brass-tapware",
   "antique-brass"
  ],
  [
   "Brushed Nickel",
   "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F130467594389",
   "brushed-nickel"
  ],
  [
   "Warm Brushed Nickel",
   "/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F231376093333",
   "warm-brushed-nickel"
  ],
  [
   "Brushed Gold",
   "/collections/brushed-gold-tapware",
   "brushed-gold"
  ],
  [
   "Gunmetal",
   "/collections/colour-gunmetal",
   "gunmetal"
  ],
  [
   "Matte White",
   "/collections/colour-matte-white",
   "matte-white"
  ],
  [
   "Matte Black",
   "/collections/colour-matte-black",
   "matte-black"
  ],
  [
   "Champagne",
   "/collections/colour-champagne",
   "champagne"
  ],
  [
   "Chrome",
   "/collections/colour-chrome",
   "chrome"
  ],
  [
   "Brushed Bronze",
   "/collections/colour-brushed-bronze",
   "brushed-bronze"
  ],
  [
   "Brushed Copper",
   "/collections/colour-brushed-copper",
   "brushed-copper"
  ],
  [
   "Black",
   "/collections/colour-black",
   "black"
  ],
  [
   "Grey",
   "/collections/colour-grey",
   "grey"
  ],
  [
   "Stainless Steel",
   "/collections/colour-stainless-steel",
   "stainless-steel"
  ],
  [
   "White",
   "/collections/colour-white",
   "white"
  ]
 ],
 "drawerCats": {
  "toilets": {
   "t": "Toilets",
   "all": "/pages/toilet-suites",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ToiletsHero_WallSuites_1.jpg",
   "hub": "/pages/toilet-suites",
   "guideT": "Toilets Hub",
   "feat": {
    "type": "prod",
    "t": "Geberit Sigma 8 Milan Rimless In Wall Suite",
    "p": 621,
    "c": 1497,
    "h": "/products/geberit-sigma-8-isabella-rimless-in-wall-cistern-toilet-suite-colour-buttons-2",
    "i": "Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg"
   },
   "groups": [
    {
     "h": "By type",
     "links": [
      {
       "l": "Back-to-Wall Suites",
       "h": "/collections/back-to-wall-toilet-suites",
       "n": 38,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-toilet-suites.png?v=1782979632",
       "cut": 1,
       "bg": "cutout",
       "pv": "BP-T3_1.webp"
      },
      {
       "l": "In-Wall Toilet Packages",
       "h": "/collections/in-wall-toilet-packages",
       "n": 25,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-toilet-packages.png?v=1782979672",
       "cut": 1,
       "bg": "cutout",
       "pv": "BEWFP_1.webp"
      },
      {
       "l": "Wall Faced Pans",
       "h": "/collections/wall-faced-pans",
       "n": 14,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-faced-pans.png?v=1782979730",
       "cut": 1,
       "bg": "cutout",
       "pv": "Aluca-Wall-Faced-Pan-Round-Shape-Buttons.jpg"
      },
      {
       "l": "Wall Hung Pans",
       "h": "/collections/wall-hung-pans",
       "n": 6,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-pans.png?v=1782979731",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Close Coupled Suites",
       "h": "/collections/close-coupled-toilet-suites",
       "n": 5,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-close-coupled-toilet-suites.png?v=1782979641",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Smart Toilets",
       "h": "/collections/smart-toilets",
       "n": 15,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-smart-toilets.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "In-wall & parts",
     "links": [
      {
       "l": "Concealed Cisterns",
       "h": "/collections/in-wall-concealed-cisterns",
       "n": 8,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-concealed-cisterns.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Cistern Buttons",
       "h": "/collections/in-wall-cistern-buttons",
       "n": 82,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-in-wall-cistern-buttons.png?v=1782979661",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bidet Sprays",
       "h": "/collections/bidet-sprays",
       "n": 21,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bidet-sprays.png?v=1782979631",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Spare Parts",
       "h": "/collections/toilet-spare-parts",
       "n": 43,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-toilet-spare-parts.png?v=1782979721",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "baths": {
   "t": "Baths",
   "all": "/pages/bathtubs",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/423807770_1049961749451743_2710686113473872051_n-1024x819.jpg",
   "hub": "/pages/bathtubs",
   "guideT": "Baths Hub",
   "feat": {
    "type": "prod",
    "t": "1700mm Artemis V-Groove Fluted Freestanding Bath",
    "p": 1038,
    "c": 2397,
    "h": "/products/1700mm-artemis-v-groove-fluted-free-standing-matte-white-bath-tub-no-overflow",
    "i": "1700mm-Artemis_a005a0d3-aa4a-42c6-bdae-15d5fb2e5891.webp"
   },
   "groups": [
    {
     "h": "By type",
     "links": [
      {
       "l": "Freestanding Baths",
       "h": "/collections/freestanding-baths",
       "n": 143,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-baths.png?v=1782979661",
       "cut": 1,
       "bg": "cutout",
       "pv": "1700mm-Artemis_a005a0d3-aa4a-42c6-bdae-15d5fb2e5891.webp"
      },
      {
       "l": "Back to Wall Baths",
       "h": "/collections/back-to-wall-baths",
       "n": 34,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-back-to-wall-baths.png?v=1782979632",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Corner Baths",
       "h": "/collections/corner-baths",
       "n": 44,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-corner-baths.png?v=1782979641",
       "cut": 1,
       "bg": "cutout",
       "pv": "vienna-lh-1.jpg"
      },
      {
       "l": "Multi-fit Baths",
       "h": "/collections/multi-fit-baths",
       "n": 13,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-multi-fit-baths.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Stone Baths",
       "h": "/collections/stone-baths",
       "n": 46,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-stone-baths.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Finish the look",
     "links": [
      {
       "l": "Bath Wastes",
       "h": "/collections/bath-wastes",
       "n": 44,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bath & Basin Spouts",
       "h": "/collections/bath-spouts",
       "n": 180,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-spouts.png?v=1782979632",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Freestanding Bath Mixers",
       "h": "/collections/freestanding-bath-mixers",
       "n": 119,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-bath-mixers.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "showers": {
   "t": "Showers",
   "all": "/pages/showers",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/455114UB-Lifestyle.jpg",
   "hub": "/pages/showers",
   "guideT": "Showers Hub",
   "feat": {
    "type": "prod",
    "t": "Ovia Brushed Gold Trade 2-in-1 Twin Rail System",
    "p": 318,
    "c": 699,
    "h": "/products/ovia-trade-2-in-1-multi-function-shower-station-brushed-gold-pvd",
    "i": "STR013-PBM90423W-32BM-scaled-1.jpg"
   },
   "groups": [
    {
     "h": "By type",
     "links": [
      {
       "l": "2-in-1 Multi Function",
       "h": "/collections/shower-column-set",
       "n": 251,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-column-set.png?v=1782979691",
       "cut": 1,
       "bg": "cutout",
       "pv": "STR013-PBM90423W-32BM-scaled-1.jpg"
      },
      {
       "l": "Hand Shower on Rail",
       "h": "/collections/shower-on-rail",
       "n": 122,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-on-rail.png?v=1782979702",
       "cut": 1,
       "bg": "cutout",
       "pv": "STR013-PBN90423W-32BN-scaled-1.jpg"
      },
      {
       "l": "Shower Heads",
       "h": "/collections/shower-heads",
       "n": 183,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-heads.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Shower Arms",
       "h": "/collections/shower-arms",
       "n": 162,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-arms.png?v=1782979691",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Hand Shower Pieces",
       "h": "/collections/hand-shower-piece",
       "n": 84,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-hand-shower-piece.png?v=1782979661",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Shower on Brackets",
       "h": "/collections/shower-brackets",
       "n": 148,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-brackets.png?v=1782979691",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Screens & mixers",
     "links": [
      {
       "l": "Shower Screens",
       "h": "/collections/shower-screens",
       "n": 49
      },
      {
       "l": "Screen Accessories",
       "h": "/collections/shower-screen-accessories",
       "n": 29,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-screen-accessories.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Shower / Wall Mixers",
       "h": "/collections/shower-wall-mixers",
       "n": 244,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wall-mixers.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "tapware": {
   "t": "Tapware",
   "all": "/pages/bathroom-tapware",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/434212207_3682553512029488_4123856708157861265_n-1024x768.jpg",
   "hub": "/pages/bathroom-tapware",
   "guideT": "Tapware Hub",
   "feat": {
    "type": "prod",
    "t": "Ovia Milan Shower Bath Mixer Brushed Bronze",
    "p": 150,
    "c": 397,
    "h": "/products/ovia-milan-shower-bath-mixer-round-brushed-bronze",
    "i": "ChatGPT-Image-Apr-8-2025-02_26_28-PM_9667e08c-69bd-4d7e-bd1f-a905afe66050.png"
   },
   "groups": [
    {
     "h": "Bathroom",
     "links": [
      {
       "l": "Basin Mixers",
       "h": "/collections/basin-mixers",
       "n": 282,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-basin-mixers.png?v=1782979631",
       "cut": 1,
       "bg": "cutout",
       "pv": "ChatGPT-Image-Apr-8-2025-02_26_28-PM_9667e08c-69bd-4d7e-bd1f-a905afe66050.png"
      },
      {
       "l": "Tall Basin Mixers",
       "h": "/collections/tall-basin-mixers",
       "n": 136,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-tall-basin-mixers.png?v=1782979720",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Wall Basin Mixers",
       "h": "/collections/wall-basin-mixers",
       "n": 171,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-basin-mixers.png?v=1782979730",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Shower / Wall Mixers",
       "h": "/collections/shower-wall-mixers",
       "n": 244,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wall-mixers.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Diverter Mixers",
       "h": "/collections/shower-mixers-diverter",
       "n": 170,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-mixers-diverter.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Freestanding Bath Mixers",
       "h": "/collections/freestanding-bath-mixers",
       "n": 119,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-bath-mixers.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Wall Taps",
       "h": "/collections/wall-tap-assemblies",
       "n": 82,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-tap-assemblies.png?v=1782979736",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bath & Basin Spouts",
       "h": "/collections/bath-spouts",
       "n": 180,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-spouts.png?v=1782979632",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Kitchen & laundry",
     "links": [
      {
       "l": "Kitchen & Laundry Mixers",
       "h": "/collections/kitchen-mixers",
       "n": 421,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-kitchenmixer-tigerbronze-lifestyle.webp"
      },
      {
       "l": "Pull Out Kitchen Mixers",
       "h": "/collections/pull-out-kitchen-mixers",
       "n": 209,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pull-out-kitchen-mixers.png?v=1782979692",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Laundry Mixers",
       "h": "/collections/laundry-mixers",
       "n": 129,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Boiling, Chilled & Sparkling",
       "h": "/collections/boiling-chilled-sparkling-taps",
       "n": 8,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-boiling-chilled-sparkling-taps.png?v=1783035921",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Filter Taps",
       "h": "/collections/filter-taps",
       "n": 9,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-filter-taps.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Pot Fillers",
       "h": "/collections/pot-fillers",
       "n": 32,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pot-fillers.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Outdoor Kitchen Taps",
       "h": "/collections/outdoor-kitchen-taps",
       "n": 11,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-outdoor-kitchen-taps.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "basins": {
   "t": "Basins",
   "all": "/pages/basins",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/ovia-fluted.webp",
   "hub": "/pages/basins",
   "guideT": "Basins Hub",
   "feat": {
    "type": "prod",
    "t": "Ovia Matte White 360mm Round Counter Top Basin",
    "p": 126,
    "c": 399,
    "h": "/products/ovia-matt-white-360mm-round-counter-top-basin",
    "i": "360-Gloss.png"
   },
   "groups": [
    {
     "h": "By type",
     "links": [
      {
       "l": "Countertop Basins",
       "h": "/collections/counter-top-basins",
       "n": 254,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-counter-top-basins.png?v=1782979640",
       "cut": 1,
       "bg": "cutout",
       "pv": "hero_basin_ac-800x445-1.jpg"
      },
      {
       "l": "Wall Hung Basins",
       "h": "/collections/wall-hung-basins",
       "n": 37,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-basins.png?v=1782979730",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Undermount Basins",
       "h": "/collections/under-basins",
       "n": 39,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-under-basins.png?v=1782979721",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Semi-inset Basins",
       "h": "/collections/semi-inset-basins",
       "n": 39,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-semi-inset-basins.png?v=1782979691",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Freestanding Basins",
       "h": "/collections/freestanding-basins",
       "n": 7,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-freestanding-basins.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Inset Basins",
       "h": "/collections/inset-basins",
       "n": 10,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-inset-basins.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Compact Basins",
       "h": "/collections/compact-basins",
       "n": 6,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-compact-basins.png?v=1782979641",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Cast Stone Basins",
       "h": "/collections/cast-stone-basins",
       "n": 61,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cast-stone-basins.png?v=1782979641",
       "cut": 1,
       "bg": "cutout",
       "pv": "ovia-fluted.webp"
      }
     ]
    },
    {
     "h": "Wastes & traps",
     "links": [
      {
       "l": "Pop-up Wastes",
       "h": "/collections/pop-up-wastes",
       "n": 47,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pop-up-wastes.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bottle Traps",
       "h": "/collections/bottle-traps",
       "n": 21,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "kitchen": {
   "t": "Kitchen",
   "all": "/collections/kitchen",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/SinkHero_Butler2-600x333-1.jpg",
   "hub": "/pages/kitchen-laundry-sinks",
   "guideT": "Kitchen & laundry Hub",
   "feat": {
    "type": "tile",
    "k": "Complete the kitchen",
    "t": "Sinks & mixers, made to match",
    "go": "Browse kitchen \u2192",
    "h": "/collections/kitchen",
    "i": "meir-kitchenmixer-tigerbronze-lifestyle.webp"
   },
   "groups": [
    {
     "h": "Sinks",
     "links": [
      {
       "l": "All Kitchen Sinks",
       "h": "/collections/sinks-laundry-tubs",
       "n": 121,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sinks-laundry-tubs.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Single Bowl Sinks",
       "h": "/collections/single-bowls",
       "n": 80,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-single-bowls.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Double Bowl Sinks",
       "h": "/collections/double-bowls",
       "n": 40,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-double-bowls.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Butler Sinks",
       "h": "/collections/butlers-ceramic-sink",
       "n": 24,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-butlers-ceramic-sink.png?v=1782979641",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Granite Sinks",
       "h": "/collections/granite-sinks",
       "n": 55,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-granite-sinks.png?v=1782979661",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Sink Accessories",
       "h": "/collections/sink-accessories",
       "n": 71,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-sink-accessories.png?v=1782979702",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Tapware",
     "links": [
      {
       "l": "Kitchen Mixers",
       "h": "/collections/kitchen-mixers",
       "n": 421,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-kitchenmixer-tigerbronze-lifestyle.webp"
      },
      {
       "l": "Pull Out Kitchen Mixers",
       "h": "/collections/pull-out-kitchen-mixers",
       "n": 209,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pull-out-kitchen-mixers.png?v=1782979692",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Boiling, Chilled & Sparkling",
       "h": "/collections/boiling-chilled-sparkling-taps",
       "n": 8,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-boiling-chilled-sparkling-taps.png?v=1783035921",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Filter Taps",
       "h": "/collections/filter-taps",
       "n": 9,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-filter-taps.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Pot Fillers",
       "h": "/collections/pot-fillers",
       "n": 32,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pot-fillers.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Finishing touches",
     "links": [
      {
       "l": "Kitchen Accessories",
       "h": "/collections/kitchen-accessories",
       "n": 46,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-kitchen-accessories.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "laundry": {
   "t": "Laundry",
   "all": "/collections/laundry-and-butler-sinks",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/meir-kitchenmixer-tigerbronze-lifestyle.webp",
   "hub": "/pages/kitchen-laundry-sinks",
   "guideT": "Kitchen & laundry Hub",
   "feat": {
    "type": "tile",
    "k": "Hard-working spaces",
    "t": "Sinks & tapware for the laundry",
    "go": "Browse laundry \u2192",
    "h": "/collections/laundry-and-butler-sinks",
    "i": "SinkHero_Butler2-600x333-1.jpg"
   },
   "groups": [
    {
     "h": "The laundry",
     "links": [
      {
       "l": "Laundry & Butler Sinks",
       "h": "/collections/laundry-and-butler-sinks",
       "n": 261,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-and-butler-sinks.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Laundry Tubs",
       "h": "/collections/laundry-tubs",
       "n": 9,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-tubs.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Laundry Mixers",
       "h": "/collections/laundry-mixers",
       "n": 129,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-laundry-mixers.png?v=1782979672",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Wall Taps",
       "h": "/collections/wall-tap-assemblies",
       "n": 82,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-tap-assemblies.png?v=1782979736",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Finishing touches",
     "links": [
      {
       "l": "Heated Towel Rails",
       "h": "/collections/heated-rails",
       "n": 131,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heated-rails.png?v=1782979661",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-verticalheatedrail-lifestyle.png"
      },
      {
       "l": "Robe Hooks",
       "h": "/collections/robe-hooks",
       "n": 122,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-robe-hooks.png?v=1782979691",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "accessories": {
   "t": "Accessories",
   "all": "/pages/bathroom-accessories",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/AccessoriesHero_Toilet.jpg",
   "hub": "/pages/bathroom-accessories",
   "guideT": "Accessories Hub",
   "feat": {
    "type": "tile",
    "k": "Complete the room",
    "t": "Matching accessories in every finish",
    "go": "Browse the range \u2192",
    "h": "/collections/bathroom-accessories",
    "i": "AccessoriesHero_Toilet.jpg"
   },
   "groups": [
    {
     "h": "Essentials",
     "links": [
      {
       "l": "Towel Bars & Rails",
       "h": "/collections/towel-bar-rails",
       "n": 406,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-towel-bar-rails.png?v=1782979721",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Toilet Paper Holders",
       "h": "/collections/paper-holders",
       "n": 126,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-paper-holders.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Robe Hooks",
       "h": "/collections/robe-hooks",
       "n": 122,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-robe-hooks.png?v=1782979691",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Towel Rings",
       "h": "/collections/towel-rings",
       "n": 70,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-towel-rings.png?v=1782979721",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bath Shelves",
       "h": "/collections/bathroom-shelves",
       "n": 47,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bathroom-shelves.png?v=1782979631",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Soap Dish Holders",
       "h": "/collections/soap-dish-holders",
       "n": 37,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-soap-dish-holders.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Soap Dispensers",
       "h": "/collections/soap-dispenser",
       "n": 15,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-soap-dispenser.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Toilet Brush Holders",
       "h": "/collections/toilet-brush-holder",
       "n": 22,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-toilet-brush-holder.png?v=1782979721",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Warm & practical",
     "links": [
      {
       "l": "Heated Towel Rails",
       "h": "/collections/heated-rails",
       "n": 131,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heated-rails.png?v=1782979661",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-verticalheatedrail-lifestyle.png"
      }
     ]
    }
   ]
  },
  "vanities": {
   "t": "Vanities",
   "all": "/pages/vanities",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/150RWC_2-1.jpg",
   "hub": "/pages/vanities",
   "guideT": "Vanities Hub",
   "feat": {
    "type": "tile",
    "k": "Design tool",
    "tag": "NEW",
    "t": "Design your dream vanity",
    "go": "Start building \u2192",
    "h": "/collections/vanity-builder",
    "i": "HE-90W-TO.webp"
   },
   "groups": [
    {
     "h": "By type",
     "links": [
      {
       "l": "Wall Hung Vanities",
       "h": "/collections/wall-hung-vanities",
       "n": 159,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wall-hung-vanities.png?v=1782979731",
       "cut": 1,
       "bg": "cutout",
       "pv": "HE-90W-TO.webp"
      },
      {
       "l": "Vanities on Legs",
       "h": "/collections/vanities-on-legs",
       "n": 22,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-legs.png?v=1782979731",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Vanities on Kickboard",
       "h": "/collections/vanities-on-kickboard",
       "n": 35,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanities-on-kickboard.png?v=1782979721",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Small Space Vanities",
       "h": "/collections/small-spaces-vanities",
       "n": 36,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-small-spaces-vanities.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Extras",
     "links": [
      {
       "l": "Stone Tops",
       "h": "/collections/stone-tops",
       "n": 16,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-stone-tops.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Vanity Tops",
       "h": "/collections/vanity-tops-bathroom-vanities",
       "n": 39,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanity-tops-bathroom-vanities.png?v=1782979730",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Cabinet Handles",
       "h": "/collections/cabinet-handles",
       "n": 140,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-cabinet-handles.png?v=1782979641",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Vanity Builder",
       "h": "/collections/vanity-builder",
       "n": 18,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-vanity-builder.png?v=1782979731",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "mirrors": {
   "t": "Mirrors & Cabinets",
   "all": "/pages/mirrors-shaving-cabinets",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/hero_kaya_led_mirror.jpg",
   "hub": "/pages/mirrors-shaving-cabinets",
   "guideT": "Mirrors & Cabinets Hub",
   "feat": {
    "type": "prod",
    "t": "Athena 500x800mm LED Arch Shaving Cabinet",
    "p": 809,
    "c": 1097,
    "h": "/products/mercio-athena-500-x-800mm-led-arch-wall-hung-shaving-cabinet-single-door",
    "i": "AT-5090A-MW1.webp"
   },
   "groups": [
    {
     "h": "Mirrors",
     "links": [
      {
       "l": "LED Mirrors",
       "h": "/collections/led-mirrors",
       "n": 82,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-led-mirrors.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Round Mirrors",
       "h": "/collections/rounds",
       "n": 13,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-rounds.png?v=1782979691",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Pencil Edge Mirrors",
       "h": "/collections/pencil-edge-mirrors",
       "n": 23,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pencil-edge-mirrors.png?v=1782979681",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Framed Coloured Mirrors",
       "h": "/collections/framed-coloured-mirrors",
       "n": 52,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-framed-coloured-mirrors.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    },
    {
     "h": "Cabinets",
     "links": [
      {
       "l": "Shaving Cabinets",
       "h": "/collections/shaving-cabinets",
       "n": 111,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shaving-cabinets.png?v=1782979691",
       "cut": 1,
       "bg": "cutout",
       "pv": "PSC1200SX-fienza-lifestyle.webp"
      },
      {
       "l": "LED Shaving Cabinets",
       "h": "/collections/led-shaving-cabinets",
       "n": 43,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-led-shaving-cabinets.png?v=1782979682",
       "cut": 1,
       "bg": "cutout",
       "pv": "AT-5090A-MW1.webp"
      }
     ]
    }
   ]
  },
  "wastes": {
   "t": "Wastes & Traps",
   "all": "/pages/shower-wastes",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/floorwaste-lifestyle.jpg",
   "hub": "/pages/shower-wastes",
   "guideT": "Wastes & Traps Hub",
   "feat": {
    "type": "tile",
    "k": "Floor & shower",
    "t": "Grates, channels & wastes",
    "go": "Browse wastes \u2192",
    "h": "/collections/floor-wastes",
    "i": "floorwaste-lifestyle.jpg"
   },
   "groups": [
    {
     "h": "By type",
     "links": [
      {
       "l": "Floor Wastes",
       "h": "/collections/floor-wastes",
       "n": 76,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-floor-wastes.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Shower Wastes",
       "h": "/collections/shower-wastes",
       "n": 88,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-shower-wastes.png?v=1782979702",
       "cut": 1,
       "bg": "cutout",
       "pv": "floorwaste-lifestyle.jpg"
      },
      {
       "l": "Wedge Wire Channels",
       "h": "/collections/wedge-wire-tile-insert-channels",
       "n": 15,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-wedge-wire-tile-insert-channels.png?v=1782979736",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bath Wastes",
       "h": "/collections/bath-wastes",
       "n": 44,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bath-wastes.png?v=1782979632",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Pop-up Wastes",
       "h": "/collections/pop-up-wastes",
       "n": 47,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-pop-up-wastes.png?v=1782979682",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Bottle Traps",
       "h": "/collections/bottle-traps",
       "n": 21,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-bottle-traps.png?v=1782979641",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "heating": {
   "t": "Heating & Cooling",
   "all": "/pages/heating-cooling",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-and-cooling.png?v=1782979661",
   "hub": "/pages/heating-cooling",
   "guideT": "Heating & Cooling Hub",
   "feat": {
    "type": "tile",
    "k": "Warm & practical",
    "t": "Heated rails & underfloor heating",
    "go": "Browse heating \u2192",
    "h": "/collections/heating-and-cooling",
    "i": "meir-verticalheatedrail-lifestyle.png"
   },
   "groups": [
    {
     "h": "Keep it warm",
     "links": [
      {
       "l": "Heated Towel Rails",
       "h": "/collections/heated-rails",
       "n": 131,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heated-rails.png?v=1782979661",
       "cut": 1,
       "bg": "cutout",
       "pv": "meir-verticalheatedrail-lifestyle.png"
      },
      {
       "l": "Underfloor Heating",
       "h": "/collections/underfloor-heating",
       "n": 62,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-underfloor-heating.png?v=1782979721",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Heating Thermostats",
       "h": "/collections/heating-thermostats",
       "n": 7,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-thermostats.png?v=1782979661",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "All Heating & Cooling",
       "h": "/collections/heating-and-cooling",
       "n": 155,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-heating-and-cooling.png?v=1782979661",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  },
  "care": {
   "t": "Care & Ambulant",
   "all": "/pages/disabled-care",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-special-disabled.png?v=1782979711",
   "hub": "/pages/disabled-care",
   "guideT": "Care & Ambulant Hub",
   "feat": {
    "type": "tile",
    "k": "Care range",
    "t": "Accessible bathroom fit-outs",
    "go": "Browse the range \u2192",
    "h": "/collections/special-disabled",
    "i": "AccessoriesHero_Care-1.jpg"
   },
   "groups": [
    {
     "h": "Accessible bathrooms",
     "links": [
      {
       "l": "All Care Products",
       "h": "/collections/special-disabled",
       "n": 57,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-special-disabled.png?v=1782979711",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Care Toilet Suites",
       "h": "/collections/disabled-toilet-suites",
       "n": 34,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-disabled-toilet-suites.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Grab Rails & Back Rests",
       "h": "/collections/grab-rails-back-rests",
       "n": 28,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-grab-rails-back-rests.png?v=1782979661",
       "cut": 1,
       "bg": "cutout"
      },
      {
       "l": "Care Tapware",
       "h": "/collections/disability-tapware",
       "n": 9,
       "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/atelier-nav-thumb-disability-tapware.png?v=1782979651",
       "cut": 1,
       "bg": "cutout"
      }
     ]
    }
   ]
  }
 },
 "mdExtra": [
  [
   "Door Hardware",
   "/collections/door-hardware"
  ],
  [
   "Commercial Range",
   "/collections/commercial-range"
  ],
  [
   "Outdoor",
   "/collections/outdoor"
  ]
 ],
 "xdExtra": {
  "doors": {
   "t": "Door Hardware",
   "all": "/collections/door-hardware",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/edge-handle-urbanbrass.webp"
  },
  "commercial": {
   "t": "Commercial Range",
   "all": "/collections/commercial-range",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/AccessoriesHero_Care-1.jpg"
  },
  "outdoor": {
   "t": "Outdoor",
   "all": "/collections/outdoor",
   "img": "https://cdn.shopify.com/s/files/1/0701/6261/2373/files/meir-shower-stainless-steel-outdoor.webp"
  }
 }
};
